import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Button, Icon } from '@pairy/pds-react';
import { theme } from '@pairy/styles';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

const spinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled(Icon)<{ isLoading: boolean }>`
  animation: ${({ isLoading }) =>
    isLoading
      ? css`
          ${spinAnimation} 1s linear infinite
        `
      : 'none'};
`;

export const DesktopButton = styled(Button)`
  width: 59px;
  height: 59px;
  opacity: ${VIEWER_Z_INDEX.desktopLayer};
  transition: opacity 0.15s ease-in-out, width 0.15s ease-in-out;

  &.disable {
    cursor: initial;
    opacity: 0.25;

    &:hover {
      border-color: ${theme.colors.zinc_200};
      background-color: ${theme.colors.white};
      color: ${theme.colors.zinc_400};
    }
  }

  &:hover {
    width: fit-content;
  }

  &.isLoading {
    width: fit-content;
  }
`;

export const MobileButton = styled(Button)`
  z-index: ${VIEWER_Z_INDEX.desktopLayer};
  width: 43px;
  height: 43px;
  padding: 8px;

  box-shadow: none;

  transition: opacity 0.15s ease-in-out;

  &.disable {
    cursor: initial;
    opacity: 0;
  }
`;
